import firebase from "firebase/app";

const getFirebaseApp = firebase.app;

export default getFirebaseApp;
